import React, { useEffect, useState } from 'react';
import $ from 'jquery';
import * as R from 'ramda';
import { createServiceData, updateServiceData, deleteServiceData, generateLettersForUserIdAndUserServiceId } from '../../../../../../../actions/facilita-api';
import ServiceData from '../../../../../../../constants/models/serviceData';
import Generic from '../../../../../../../constants/models/servicePayloads/generic';
import { convertConnectionTypesToServiceType } from '../../../../../../../constants/utils/connectionTypes';
import { useDispatch, useSelector } from 'react-redux';
import * as Loadings from '../../../../../../../constants/loadings/service';

export const GenericDetails = ({ customServiceData, inputOnFocus, connectionType, boxIndex, setShowCustomBox, customFormRef, removeBranch, serviceDatas, isLoading, userId, generateLetters }) => {
    var countries = require("i18n-iso-countries");
    countries.registerLocale(require("i18n-iso-countries/langs/fr.json"));
    const dispatch = useDispatch();
    const services = useSelector(state => state.services);
    const [payloads, setPayloads] = useState({ items: [{ id: '', payload: new Generic({ reference: '', comment: '' }) }] });
    const [toDelete, setToDelete] = useState([]);
    const [autoFocus, setAutoFocus] = useState(false);

    function loadReferences() {
        let allServicesWithSameBranch = serviceDatas.filter(b => b.serviceId === customServiceData.serviceId);
        let tmpPayloads = { items: payloads.items.filter(i => toDelete.findIndex(d => d === i.id) === -1) };
        allServicesWithSameBranch.forEach(br => {
            if (tmpPayloads.items.findIndex(tmp => tmp.id === br.id) === -1) {
                tmpPayloads.items.push({ id: br.id, payload: br.payload });
            }
        });
        if (allServicesWithSameBranch.length > 0 && tmpPayloads.items.length > 0) {
            if (tmpPayloads.items[0].payload.reference === '') {
                tmpPayloads.items.splice(0, 1);
            }
            setPayloads(tmpPayloads);
        }
        setToDelete([]);
    }

    useEffect(() => {
        loadReferences();
        $('[data-toggle="tooltip"]').tooltip();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        loadReferences();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [serviceDatas]);

    return (
        <div>
            <div className="form-block">
                {
                    payloads.items.map((br, index) => {
                        return (
                            <div className="form-row">
                                <div className="col form-group mb-xs">
                                    <div className="flex-row gx-2 align-items-center mb-1">
                                        <label className="h6 font-weight-bolder my-auto" htmlFor={"reference" + index + '-' + boxIndex} >Référence</label>
                                        <p className="form-text small text-gray my-auto ml-auto" data-toggle="tooltip" data-placement="top" data-html="true" data-template='<div class="tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner px-3 py-2 fs-2"></div></div>' title="Une référence permet à vos organismes de vous identifier afin de faire les démarches nécessaires."><i className="eva eva-info-outline mr-1 fs-sm lh-root align-middle"></i></p>
                                    </div>
                                    <input required={true} pattern=".*\S+.*" autoFocus={inputOnFocus || (autoFocus && index === payloads.items.length - 1)} type="text" className="form-control rounded" id={"reference" + index + '-' + boxIndex} placeholder="xxxxxxxxxxx" aria-describedby="basic-addon2" value={!R.isNil(br) && !R.isNil(br.payload) ? br.payload.reference : ''} onChange={(e) => {
                                        e.preventDefault();
                                        setPayloads({ ...payloads, items: payloads.items.map((i) => {
                                            if(i.id !== br.id){
                                                return i;
                                            }else{
                                                return {...br,  payload: {...br.payload, reference: e.target.value} };
                                            }
                                        })});
                                    }} />
                                </div>
                                <div className="col form-group mb-xs">
                                    <div className="flex-row gx-2 align-items-center mb-1">
                                        <label htmlFor={"referenceComentaire" + index + '-' + boxIndex} className="label h6 lh-root font-weight-bold">Commentaire</label>
                                        <p className="form-text small text-gray my-auto ml-auto" data-toggle="tooltip" data-placement="top" data-html="true" data-template='<div class="tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner px-3 py-2 fs-2"></div></div>' title="Les cases commentaires sont personnelles (ne seront pas visibles par le mandataire), elles vous permettent d'ajouter des notes à vos services."><i className="eva eva-info-outline mr-1 fs-sm lh-root align-middle"></i></p>
                                    </div>
                                    <div className="input-group mb-0">
                                        <input type="text" className="form-control rounded" id={"referenceComentaire" + index + '-' + boxIndex} placeholder="xxxxxxxxxxx" value={!R.isNil(br) && !R.isNil(br.payload) ? br.payload.comment : ''} onChange={(e) => {
                                            e.preventDefault();
                                            setPayloads({ ...payloads, items: payloads.items.map((i) => {
                                                if(i.id !== br.id){
                                                    return i;
                                                }else{
                                                    return {...br,  payload: {...br.payload, comment: e.target.value} };
                                                }
                                            })});
                                        }} />
                                        {(index === 0 ? br.payload.reference !== '' : true) ?
                                            <span className="btn btn-sm btn-icon px-xs btn-alert-danger ml-1 border-none rounded" id="basic-addon2" onClick={(e) => {
                                                e.preventDefault();
                                                if (!R.isNil(br.id) && br.id !== '') {
                                                    let tmpToDelete = toDelete.concat(br.id);
                                                    setToDelete(tmpToDelete);
                                                    dispatch(deleteServiceData(br.id, connectionType));
                                                }
                                                let newPayload = payloads.items.filter((p, idx) => idx !== index);
                                                if (newPayload.length === 0) {
                                                    newPayload.push({ id: '', payload: new Generic({ reference: '', comment: '' }) });
                                                }
                                                setPayloads({ ...payloads, items: newPayload });
                                            }}><i className="eva eva-trash-2-outline"></i></span>

                                            : ''}
                                    </div>
                                </div>
                                <div className={"col invalid-feedback alert-danger alert"}>Champs invalide</div>
                            </div>
                        )
                    })
                }
                {
                    <button type="button" className="btn btn-icon p-0 align-middle text-gray no-outline mr-auto mb-xs" disabled={R.isNil(customServiceData) || R.isNil(customServiceData.serviceId) || customServiceData.serviceId === ''}
                        onClick={
                            (e) => {
                                e.preventDefault();
                                setPayloads({ ...payloads, items: payloads.items.concat({ id: '', payload: new Generic({ reference: '', comment: '' }) }) });
                                setAutoFocus(true);
                            }
                        }
                    >
                        <i className="eva eva-plus-circle-outline fs-lead align-middle text-secondary mr-1"></i>
                        <span className="btn-text aling-middle">Ajouter une autre référence</span>
                    </button>
                }
            </div>

            <hr className="my-0" />
            <div className="card-footer">
                <button className={"btn btn-sm btn-alert-info border-none loading-btn"+((R.isNil(customServiceData) && isLoading.includes(Loadings.ADD_NEW_SERVICE+'custom')) || (!R.isNil(customServiceData) && isLoading.includes(Loadings.UPDATING_SERVICE_DATA+customServiceData.id) ? ' show': ''))}
                    disabled={(R.isNil(customServiceData) && isLoading.includes(Loadings.ADD_NEW_SERVICE+'custom')) || (!R.isNil(customServiceData) && isLoading.includes(Loadings.UPDATING_SERVICE_DATA+customServiceData.id))}
                    onClick={(e) => {
                        e.preventDefault();
                        customFormRef.current.classList.add('was-validated');
                        if (customFormRef.current.checkValidity()) {
                            payloads.items.length > 0 && payloads.items.forEach(payload => {
                                let serviceData = new ServiceData({ userId: userId, serviceType: convertConnectionTypesToServiceType(connectionType), serviceId: !R.isNil(customServiceData.serviceId) && !R.isNil(customServiceData.id) ? customServiceData.id : !R.isNil(customServiceData.serviceId) && customServiceData.serviceId !== '' ? customServiceData.serviceId :   'custom', customServiceDetails: customServiceData.customServiceDetails, payload: payload.payload });
                                if (R.isNil(serviceData.serviceId) || serviceData.serviceId === ''){
                                    serviceData.serviceId = customServiceData.id !== '' ? customServiceData.id : 'custom';
                                }
                                if (R.isNil(payload.id) || payload.id === '') {
                                    dispatch(createServiceData(serviceData)).then((s) => {
                                        if(generateLetters){
                                            dispatch(generateLettersForUserIdAndUserServiceId(userId, s.id))
                                        }
                                    });
                                    setShowCustomBox(false);
                                }
                                else {
                                    serviceData.id = customServiceData.id;
                                    dispatch(updateServiceData(serviceData));
                                }
                            });
                            setPayloads({ payloads, items: payloads.items.filter(i => i.id !== '') });
                            setToDelete([]);
                        }
                    }}>
                    enregistrer
                            <div className="loading loading-spinner spinner-border spinner-border-sm ml-2 mr-n1"></div>
                </button>
                <span className="btn btn-sm btn-icon px-xs btn-alert-danger ml-1 border-none" id="basic-addon2" onClick={(e) => {
                    e.preventDefault();
                    if (R.isNil(customServiceData) || R.isNil(customServiceData.serviceId)) {
                        setShowCustomBox(false);
                        if (!R.isNil(removeBranch)) {
                            removeBranch(customServiceData.serviceId);
                        }
                    } else {
                        let allServicesToDelete = serviceDatas.filter(s => s.serviceId === customServiceData.serviceId);
                        allServicesToDelete.forEach(s => {
                            dispatch(deleteServiceData(s.id, connectionType));
                        });
                    }
                    if (boxIndex === 0) {
                        setShowCustomBox(false);
                    }
                }}><i className="eva eva-trash-outline"></i></span>
            </div>
        </div>
    );
}